export function ensureGoodreadsUrlIsValid(url) {
  if(url.startsWith('goodreads.com')) {
    url = `www.${url}`;
  }
  if(url.startsWith('www.')) {
    url = `https://${url}`;
  }
  return url
}

export function ensureGoodreadsUrlIsShort(url) {
  return url.replace(/https:\/\/www\./, '');
}



// WEBPACK FOOTER //
// ./source/js/utils/goodreads.ts